import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["planSelect", "ticketSelect"]

  toggleProductType() {
    const itemType = event.target.value

    if (itemType === 'plan') {
      this.planSelectTarget.style.display = 'block'
      this.ticketSelectTarget.style.display = 'none'
      this.ticketSelectTarget.querySelector('select').value = ''
    } else if (itemType === 'ticket') {
      this.planSelectTarget.style.display = 'none'
      this.ticketSelectTarget.style.display = 'block'
      this.planSelectTarget.querySelector('select').value = ''
    } else {
      this.planSelectTarget.style.display = 'none'
      this.ticketSelectTarget.style.display = 'none'
    }
  }
}
